<template>
  <div id="identity">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="sign-in-alt" />
      請選擇登入身分
      <v-font slot="etext" font-css="ml-3" font-text="Choose your Identity" />
    </v-title>
    <hr />
    <div class="container pt-identity">
      <div class="row">
        <!-- 校內人士 -->
        <fieldset class="col-sm textalign mb-4">
          <legend class="sr-only">校內人士 On-campus</legend>
          <font-awesome-icon class="iconimg" icon="user-graduate" size="5x" aria-hidden="true" />
          <br />
          <span class="d-block" aria-hidden="true">
            校內人士(On-campus)
          </span>
          <v-button
            class="lh-fs mr-2"
            btn-text="在校生"
            btn-outline="primary"
            @click.native="ToLink('school')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="Student" />
          </v-button>
          <v-button
            class="lh-fs mr-2"
            btn-text="教師"
            btn-outline="primary"
            @click.native="ToLink('teacher')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="Faculty" />
          </v-button>
          <v-button
            class="lh-fs mr-2"
            btn-text="職員"
            btn-outline="info"
            @click.native="ToLink('Staff')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="Staff" />
          </v-button>
          <v-button
            class="lh-fs mr-2 buts"
            btn-text="校友"
            btn-outline="dark"
            @click.native="ToLink('Alumni')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="Alumni" />
          </v-button>
        </fieldset>

        <!-- 校外人士 -->
        <fieldset class="col-sm textalign">
          <legend class="sr-only">校外人士 Off-campus</legend>
          <font-awesome-icon class="iconimg" icon="user-tie" size="5x" aria-hidden="true" />
          <br />
          <span class="d-block" aria-hidden="true">
            校外人士(Off-campus)
          </span>
          <v-button
            class="lh-fs mr-2"
            btn-text="一般民眾"
            btn-outline="primary"
            @click.native="ToLink('Naturalpersons')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="General Public" />
          </v-button>
          <!-- 廠商 -->
          <v-button
            class="lh-fs mr-2"
            btn-text="廠商"
            btn-outline="primary"
            @click.native="ToLink('firm')"
          >
            <br slot="eg" />
            <v-font slot="icon" font-css="spanfss" font-text="Vendor" />
          </v-button>
        </fieldset>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: 'Identity',
  methods: {
    ToLink (data) {
      this.$router.push({
        name: 'Home_Login',
        params: {
          identity: data
        }
      })
    }
  }
}
</script>

<style lang="scss">
@media only screen and (max-width: 420px) {
  .iconimg {
    font-size: 3rem;
  }
}
@media only screen and (max-width: 360px) {
  .buts {
    margin-top: 0.5rem !important;
  }
}
#identity {
  height: 500px;
  @media only screen and (max-width: 991px) {
    height: 400px;
  }
}
.pt-identity {
  padding-top: 100px;
  @media only screen and (max-width: 991px) {
    padding-top: 10px;
  }
}
</style>
